module.exports = __webpack_public_path__ + "static/media/marshall-island.7ea01805.svg";